import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';  
import { HomeComponent } from './home.component';
import { HeaderComponent } from './header/header.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { ModalLoginComponent } from './modal-login/modal-login.component';
import { ModalRegisterComponent } from './modal-register/modal-register.component';
import { ModalRecuperarComponent } from './modal-recuperar/modal-recuperar.component';
import { HomeRoutingModule } from './home-routing.module';
import { FormsModule, ReactiveFormsModule,  } from '@angular/forms';
import { FooterComponent } from './footer/footer.component';
import { ModalRegisterPendingComponent } from './modal-register-pending/modal-register-pending.component';
import { ResetPassComponent } from './reset-pass/reset-pass.component';
import { ModalTerminosComponent } from './modal-terminos/modal-terminos.component';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { LoadingBarHttpClientModule } from '@ngx-loading-bar/http-client';
import { LoadingBarRouterModule } from '@ngx-loading-bar/router';


@NgModule({
  declarations: [
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    DashboardComponent,
    ModalLoginComponent,
    ModalRegisterComponent,
    ModalRecuperarComponent,
    ModalRegisterPendingComponent,
    ResetPassComponent,
    ModalTerminosComponent,
  ],
  exports: [ 
    FooterComponent, 
    ModalLoginComponent, 
    ModalRegisterComponent,     
    ModalRecuperarComponent 
  ],
  imports: [
    HomeRoutingModule,
    CommonModule,    
    FormsModule,
    ReactiveFormsModule,   
    LoadingBarHttpClientModule,
    // for Router use:
    LoadingBarRouterModule,
    // for Core use:
    LoadingBarModule
  ]
})
export class HomeModule { }
